export default {"src":"/_next/static/media/zynoff_hero_image.925a8f64.svg","height":1717,"width":1523,"blurWidth":0,"blurHeight":0};